// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30ziw","select":"styles_select__2I1eF"};